import {  Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ChooseIconComponent, } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';
// import { ChooseIconComponent } from '../../../../basic/icon/choose-icon/choose-icon.component';


@Component({
  selector: 'atw-favorite-admin-config',
  templateUrl: './favorite-admin-config.component.html',
  styleUrls: ['./favorite-admin-config.component.scss']
})
export class AtwFavoriteAdminConfig extends AtwUpdateDbComponent implements OnInit {

 @Input() config: any = {}; // là desktop_config hoặc mobile_config
   @Input() class: any;  // là desktop_class hoặc mobile class
   @Input() objectChoosing: any; // xác định object hiệu ứng đang chọn để cấu hình
   @Input() staticdata: any;  // biến lưu staticdata trong json.
   @Input() device: any; // xác định thiết bị 
   @Output() closeConfigTool = new EventEmitter();
   @Input() visible_config_tool = false; // biến kiểm tra đóng mở khi gọi hộp thoại
   @Output() iconSelected = new EventEmitter<any>();
   isViewAll = false; // biến check để mở thêm các confg ở phần mở rộng 
   fonts = [];  // biến lưu danh sách các fonts chữ 
   effect_hover = []; // danh sách các hiệu ứng
   customize = [];  // biến lưu hiệu ứng được chọn
   effect_hover_data: any = {}; // dữ liệu tất cả hiệu ứng
   currentViewAll = { title: '', index: 0 };
   selectTypeIcon: string = 'icon';
   is_favorited: boolean = false;
   styles_field = [
     {
       title: 'dieu_chinh_vien',
       index: 1,
     },
     {
       title: 'hieu_ung',
       index: 2,
     },
     {
       title: 'lat_hinh',
       index: 3,
     },
 
   ];
 
   openMap: any = {
     menu1: {
       open: true,
       menuChild: {}
     },
     menu2: {
       open: false,
       menuChild: {}
     },
     menu3: {
       open: false,
       menuChild: {
         menu4: false,
         menu5: false,
         menu6: false,
         menu7: false,
         menu8: false,
         menu9: false
       }
     },
 
   };
   configMode: 'basic' | 'advanced' = 'basic';
 
   constructor(
     private dialog: MatDialog,
     public vhQueryAutoWeb: VhQueryAutoWeb,
     private http: HttpClient,
     public vhEventMediator: VhEventMediator,
         public functionService: FunctionService
   ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
   }
 
   ngOnInit(): void {
     forkJoin([
       this.http.get('assets/data/effects/icon.json'),
     ]).subscribe(([effects]: any) => {
       this.effect_hover = effects;
       this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
     });
   }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }
 
   openHandler(value: string): void {
     for (const key in this.openMap) {
       if (key !== value) {
         this.openMap[key].open = false;
       }
     }
   }
 
   /**
    * Hàm mở ra hộp thoại chọn icon
    */
   openDialogChooseIcon() {
     this.visible_config_tool = false;
     const dialogRef = this.dialog.open(ChooseIconComponent, {
       width: '80vw',
       height: '70vh',
       disableClose: false,
     });
     dialogRef.afterClosed().subscribe((result) => {
       if (result) {
         this.staticdata[this.staticdata.is_favorited ? '+icon': '-icon'] = result.icon;
         this.updateStaticData()
       }
       this.visible_config_tool = true;
     });
   }
  //  /**
  //   * Hàm update object vào database.
  //   */
  //  updateObject() {
  //    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //      [this.device + '_class']: this.class,
  //      [this.device + '_config']: this.config,
  //      staticdata: this.staticdata
  //    }).then((bool: any) => {
       
  //    })
  //  }
  //  /**
  // *Hàm update class vào database.
  // */
  //  updateClass() {
  //    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
  //      [this.device + '_class']: this.class
  //    }).then((bool: any) => {
       
  //    })
 
  //  }
  //  /**
  // *Hàm update config vào database.
  // */
  //  updateConfig() {
  //    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //      .then((bool: any) => {
         
  //      })
  //  }
  //  /**
  //   * Cập nhật staticdata vào database.
  //   */
  //  updateStaticData() {
  //    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //      .then((bool) => {
         
  //      });
  //  }
  
   // hàm cập nhật bộ lọc hình ảnh
   updateFilter(value: any) {
     this.config.style_filter.filter_blur = value;
     this.class[this.staticdata.is_favorited ? '+icon__primary': '-icon__primary']['filter'] = "brightness(" + this.config.style_filter.filter_brightness + "%) "
       + "saturate(" + this.config.style_filter.filter_saturate + "%) "
       + "blur(" + this.config.style_filter.filter_blur + "px) "
       + "hue-rotate(" + this.config.style_filter.filter_hue_rotate + "deg) "
       + "contrast(" + this.config.style_filter.filter_contrast + "%) "
       + "opacity(" + this.config.style_filter.filter_opacity + "%) "
       + "grayscale(" + this.config.style_filter.filter_grayscale + "%) "
 
   }
 
   /**
    * Hàm kiểm tra đóng mở của menu config ở phần mở rộng
    */
   openViewAll(field) {
     this.currentViewAll = field;
     this.isViewAll = !this.isViewAll;
   }
 
   //Hàm biến đổi transform cho icon
 
   handleSetTransform(axis) {
 
     switch (axis) {
       case 'x': // ---Lật dọc
         if (this.config['transform'].transform_rotateX < 360) {
           this.config['transform'].transform_rotateX += 180;
           this.class[this.staticdata.is_favorited ? '+icon__primary': '-icon__primary'].transform =
             'rotateX(' +
             this.config['transform'].transform_rotateX +
             'deg) ' +
             'rotateY(' +
             this.config['transform'].transform_rotateY +
             'deg) ' +
             'rotateZ(' +
             this.config['transform'].transform_rotateZ +
             'deg) ' +
             'skewX(' +
             this.config['transform'].transform_skewX +
             'deg) ' +
             'skewY(' +
             this.config['transform'].transform_skewY +
             'deg) ';
         } else {
           this.config['transform'].transform_rotateX -= 360;
           this.class[this.staticdata.is_favorited ? '+icon__primary': '-icon__primary'].transform =
             'rotateX(' +
             this.config['transform'].transform_rotateX +
             'deg) ' +
             'rotateY(' +
             this.config['transform'].transform_rotateY +
             'deg) ' +
             'rotateZ(' +
             this.config['transform'].transform_rotateZ +
             'deg) ' +
             'skewX(' +
             this.config['transform'].transform_skewX +
             'deg) ' +
             'skewY(' +
             this.config['transform'].transform_skewY +
             'deg) ';
         }
         break;
       case 'y': // ---Lật ngang
         if (this.config['transform'].transform_rotateY < 360) {
           this.config['transform'].transform_rotateY += 180;
           this.class[this.staticdata.is_favorited ? '+icon__primary': '-icon__primary'].transform =
             'rotateX(' +
             this.config['transform'].transform_rotateX +
             'deg) ' +
             'rotateY(' +
             this.config['transform'].transform_rotateY +
             'deg) ' +
             'rotateZ(' +
             this.config['transform'].transform_rotateZ +
             'deg) ' +
             'skewX(' +
             this.config['transform'].transform_skewX +
             'deg) ' +
             'skewY(' +
             this.config['transform'].transform_skewY +
             'deg) ';
         } else {
           this.config['transform'].transform_rotateY -= 360;
           this.class[this.staticdata.is_favorited ? '+icon__primary': '-icon__primary'].transform =
             'rotateX(' +
             this.config['transform'].transform_rotateX +
             'deg) ' +
             'rotateY(' +
             this.config['transform'].transform_rotateY +
             'deg) ' +
             'rotateZ(' +
             this.config['transform'].transform_rotateZ +
             'deg) ' +
             'skewX(' +
             this.config['transform'].transform_skewX +
             'deg) ' +
             'skewY(' +
             this.config['transform'].transform_skewY +
             'deg) ';
         }
         break;
       case '-z': // --- Xoay trái
         if (this.config['transform'].transform_rotateZ > -360) {
           this.config['transform'].transform_rotateZ -= 45;
           this.class[this.staticdata.is_favorited ? '+icon__primary': '-icon__primary'].transform =
             'rotateX(' +
             this.config['transform'].transform_rotateX +
             'deg) ' +
             'rotateY(' +
             this.config['transform'].transform_rotateY +
             'deg) ' +
             'rotateZ(' +
             this.config['transform'].transform_rotateZ +
             'deg) ' +
             'skewX(' +
             this.config['transform'].transform_skewX +
             'deg) ' +
             'skewY(' +
             this.config['transform'].transform_skewY +
             'deg) ';
         }
         break;
       case 'z': // --- Xoay phải
         if (this.config['transform'].transform_rotateZ < 360)
           this.config['transform'].transform_rotateZ += 45;
         this.class[this.staticdata.is_favorited ? '+icon__primary': '-icon__primary'].transform =
           'rotateX(' +
           this.config['transform'].transform_rotateX +
           'deg) ' +
           'rotateY(' +
           this.config['transform'].transform_rotateY +
           'deg) ' +
           'rotateZ(' +
           this.config['transform'].transform_rotateZ +
           'deg) ' +
           'skewX(' +
           this.config['transform'].transform_skewX +
           'deg) ' +
           'skewY(' +
           this.config['transform'].transform_skewY +
           'deg) ';
         break;
       default:
     }
 
     this.updateObject();
   }
 
  
 
   //Hàm cập nhật giá trị transform
   SetTransform() {
     this.class['icon__primary'].transform =
       'rotateX(' +
       this.config['transform'].transform_rotateX +
       'deg) ' +
       'rotateY(' +
       this.config['transform'].transform_rotateY +
       'deg) ' +
       'rotateZ(' +
       this.config['transform'].transform_rotateZ +
       'deg) ' +
       'skewX(' +
       this.config['transform'].transform_skewX +
       'deg) ' +
       'skewY(' +
       this.config['transform'].transform_skewY +
       'deg) ';
   }
 
 
   /**
  * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
  * @param event customize sau khi thay đổi
  */
   openAnimationDetail(event) {
     this.customize = event;
     this.openViewAll(this.styles_field[1])
   }
 
 
}
